<app-header
  (go-back)="goToMain()"
  [title]="getToolbarTitle()"
></app-header>
<div class="container">
  <div class="selected-image-area">
    <img alt="The image that was chosen to be replaced" i18n-alt [src]="getCurrentlySelectedImageFromFile()[0].base64.toString()">
  </div>
  <app-oer-formular (submit)="makeOer($event)" button-text="Make OER" i18n-button-text></app-oer-formular>
</div>
